// extracted by mini-css-extract-plugin
var _1 = "modal___g6G7h";
export { _1 as "modal" }
